import { useState, useRef, useEffect } from 'react';
import { ReactComponent as PauseIcon } from './pause-icon.svg';
import { ReactComponent as PlayIcon } from './play-icon.svg';
import "./styles.css";

export default function AudioPlayer({ src }) {
    const audioRef = useRef(null);
    const [duration, setDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);
    const [isPlaying, setisPlaying] = useState(false);

    // Загрузка продолжительности аудио
    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;

        const handleLoadedMetadata = () => {
            setDuration(audio.duration);
        }

        audio.addEventListener('loadedmetadata', handleLoadedMetadata);

        return () => audio.removeEventListener('loadedmetadata', handleLoadedMetadata);
    }, [])

    // Обновление времени воспроизведения
    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;

        const handleTimeUpdate = () => {
            setCurrentTime(audio.currentTime);
        }

        audio.addEventListener('timeupdate', handleTimeUpdate);

        return () => audio.removeEventListener('timeupdate', handleTimeUpdate);
    }, [])

    const tooglePlayPause = () => {
        const audio = audioRef.current;
        if (!audio) return;

        if (isPlaying) {
            audio.pause();
        } else {
            audio.play();
        }

        setisPlaying(!isPlaying);
    }

    // Перемотка
    const handleSeek = (e) => {
        const audio = audioRef.current;
        if (!audio) return;

        const newTime = parseFloat(e.target.value);
        audio.currentTime = newTime;
        setCurrentTime(newTime);
    }

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }

    return (
        <div className='audio-wrapper'>
            <audio ref={audioRef} src={src} preload='metadata' />

            <div className='audio__controls-wrapper'>
                <button onClick={tooglePlayPause}>
                    {isPlaying ? (
                        <PauseIcon height='12px' width='12px' />
                    ) : (
                        <PlayIcon height='12px' width='12px'/>
                    )}
                </button>
                <span>
                    {formatTime(currentTime)}/{formatTime(duration)}
                </span>
            </div>

            <div className='audio__range-wrapper'>
                <input
                    className='audio__range-input'
                    type='range'
                    max={duration || 0}
                    value={currentTime}
                    onChange={handleSeek}
                />
            </div>
        </div>
    )

}